export namespace Assets {
  export const images = {
    og: "https://assets.iyk-dev.app/slander/og-image.jpg",
    logo: {
      light: {
        centered: "https://assets.iyk-dev.app/slander/slander-logo-center-light.svg",
        leftAligned: "https://assets.iyk-dev.app/slander/slander-logo-left-light.svg",
      },
      dark: {
        centered: "https://assets.iyk-dev.app/slander/slander-logo-center-dark.svg",
        leftAligned: "https://assets.iyk-dev.app/slander/slander-logo-left-dark.svg",
      },
    },
    layoutBackground: "https://assets.iyk-dev.app/slander/star-background.webp",
    shopMerch: {
      light: "https://assets.iyk-dev.app/slander/profile/shop-merch-light.jpg",
      dark: "https://assets.iyk-dev.app/slander/profile/shop-merch-dark.webp",
    },
    exploreProfile: "https://assets.iyk.app/disturbed/email/explore-profile.png",
    emptyCollectionBackground:
      "https://assets.iyk.app/disturbed/profile/empty-collection-background.png",
    festivalMap: "https://assets.iyk-dev.app/slander/festival-map.webp",
    howItWorks: {
      step1: "https://assets.iyk-dev.app/slander/how-it-works/tap.webp",
      step2: "https://assets.iyk-dev.app/slander/how-it-works/visit.webp",
    },
    welcomeLandingBackground: "https://assets.iyk-dev.app/slander/welcome-background.webp",
    userCardStarBackground: "https://assets.iyk-dev.app/slander/star-letters.webp",
    buttonTexture: "https://assets.iyk-dev.app/slander/button-texture.webp",
    email: {
      logo: {
        centered: "https://assets.iyk-dev.app/slander/email/header-logo-center.png",
      },
    },
    rouletteBaseUrl: "https://assets.iyk-dev.app/slander/roulette",
  }

  export const documents = {
    rules: "https://assets.iyk-dev.app/slander/Starbase-Giveaway-Terms-Conditions.pdf",
    privacyPolicy: "https://assets.iyk.app/iyk-privacy-policy.pdf",
    termsOfService: "https://assets.iyk.app/iyk-terms-of-service.pdf",
  }
}
